import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import { some } from 'lodash-es';

import { CkeditorConstants, removeDefaultHtmlSpanAttributes } from '../../src/utils';

const {
  elementClass: { CK_SPAN },
  htmlElement: { AUDIO, LINK_SPAN, SPAN, INLINE_SPAN, KEYWORD_SPAN, IMAGE },
  helperAttributes: { CITATION_COUNT, NUMBERED_CITATION },
} = CkeditorConstants;
export default class SpanEditing extends Plugin {
  init() {
    const editor = this.editor;
    const schema = editor.model.schema;
    const conversion = this.editor.conversion;

    const customSchema = {
      isInline: true,
      inheritAllFrom: '$block',
      allowWhere: ['$block', '$text'],
      allowAttributes: ['style']
    }

    schema.register(SPAN, {
      ...customSchema,
      inheritAllFrom: '$documentFragment',
      isLimit: false
    });

    schema.register(LINK_SPAN, customSchema);

    // Schema to retain empty span tags with rdfa markup created by template
    schema.register(INLINE_SPAN, customSchema);

    schema.register(KEYWORD_SPAN, {
      ...customSchema,
      inheritAllFrom: '$documentFragment',
      isLimit: false
    });

    conversion.for('editingDowncast').elementToElement({
      model: LINK_SPAN,
      view: this.createSpanViewElement.bind(this)
    });

    conversion.for('dataDowncast').elementToElement({
      model: LINK_SPAN,
      view: this.createSpanViewElement.bind(this)
    });

    conversion.for('dataDowncast').elementToElement({
      model: INLINE_SPAN,
      view: this.createSpanViewElement.bind(this)
    });

    conversion.for('editingDowncast').elementToElement({
      model: INLINE_SPAN,
      view: this.createSpanViewElement.bind(this)
    });

    conversion.for('dataDowncast').elementToElement({
      model: KEYWORD_SPAN,
      view: this.createSpanViewElement.bind(this)
    });

    conversion.for('editingDowncast').elementToElement({
      model: KEYWORD_SPAN,
      view: this.createSpanViewElement.bind(this)
    });

    editor.conversion.for('upcast').elementToElement({
      view: {
        name: SPAN,
        attributes: [CITATION_COUNT]
      },
      model: (viewElement, { writer: modelWriter }) => {
        return modelWriter.createElement(NUMBERED_CITATION, viewElement.getAttributes());
      },
      converterPriority: 'high'
    });

    ['audio', 'img'].forEach(modelEle => {
      editor.conversion.for('downcast').elementToElement({
        model: modelEle,
        view: (modelElement, conversionApi) => {
          const { writer } = conversionApi;
          // Remove htmlSpan attribute which will create additional span tag as per GHS config 
          // Attribute removal in model element for inline audio and inline image
          removeDefaultHtmlSpanAttributes(modelElement, this.editor);
          // Return audio and image element without htmlSpan attribute
          return writer.createContainerElement(modelEle, modelElement.getAttributes());
        },
        converterPriority: 'high'
      })
    });

    editor.conversion.for('upcast').elementToElement({
      view: 'span',
      model: (viewElement, { writer: modelWriter }) => {
       try {
         if (!viewElement._classes?.has('ck-span') && !viewElement.hasStyle('font-variant') && viewElement.getAttribute('style') !== 'font-variant: "small-caps"' && !(viewElement.parent.name && viewElement.parent.name === "li" && viewElement.isEmpty && viewElement._attrs.size === 0)) {
          return modelWriter.createElement(SPAN, viewElement.getAttributes());
        } else if (viewElement._classes.has(CK_SPAN) && [...viewElement.getChildren()].find(ele => ele.name === AUDIO)) {
          if (viewElement._children.length > 1 && viewElement._children[0]._textData?.trim() === '') {
            viewElement._children[0]._remove();
          }
          return modelWriter.createElement('inlineaudio');
        } else if (viewElement._classes.has('ck-span') && this.findImgTag(viewElement)) {
          return modelWriter.createElement('inlineimage', viewElement.getAttributes());
        } else {
          return false;
        }
       } catch(err) {
        console.log('Error in span upcast', err)
       }
      }
    });

    editor.conversion.for('downcast').elementToElement({
      model: SPAN,
      view: SPAN
    });

    editor.conversion.for('upcast').elementToElement({
      model: SPAN,
      view: SPAN
    });
  }

  createSpanViewElement(modelItem, { writer: viewWriter }) {
    removeDefaultHtmlSpanAttributes(modelItem, this.editor);
    return viewWriter.createContainerElement(SPAN, modelItem.getAttributes());
  }

  findImgTag(viewElement) {
    return some([...viewElement.getChildren()], item => item.name === SPAN && item.getChild(0)?.name === IMAGE);
  }

  
  findImgTag(viewElement){
    return [...viewElement.getChildren()].some(item => item.name === SPAN && item.getChild(0).name === IMAGE);
  };
}
